import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-modal',
  templateUrl: './spinner-modal.component.html',
  styleUrls: ['./spinner-modal.component.css']
})
export class SpinnerModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
